import React from 'react';
import { Image } from 'react-native';
import FullPageSimulator from '../../FullPageSimulator';
import { img_picture_collage } from '../../../../../utils/ImagesManagementUtils';

//= ========================================================================
const ReferenceUploadPhotoFP = ({
  globJSON,
  simPlatform,
  subCategoryId,
  TopTitle,
  WithGrayBackground,
  slideshowRefs,
}) => {
  const { reference } = globJSON.configurations.services[subCategoryId];
  const myStyles = {
    bigImageStyle: {
      width: '100%', height: 221, alignSelf: 'center',
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={reference.select_a_photo}
      TopTitle={TopTitle}
      WithGrayBackground={WithGrayBackground}
      slideshowRefs={slideshowRefs}
      withCheckIconOnTop
    >
      <Image
        fadeDuration={0}
        style={myStyles.bigImageStyle}
        source={img_picture_collage}
      />
    </FullPageSimulator>
  );
};
export default ReferenceUploadPhotoFP;
